/** @hidden */
export const internalZoomFactorChange = 'internalZoomFactorChange';
/** @hidden */
export const contentChangeEvent = 'contentChange';
/** @hidden */
export const documentChangeEvent = 'documentChange';
/** @hidden */
export const selectionChangeEvent = 'selectionChange';
/** @hidden */
export const zoomFactorChangeEvent = 'zoomFactorChange';
/** @hidden */
export const beforeFieldFillEvent = 'beforeFieldFill';
/** @hidden */
export const afterFieldFillEvent = 'afterFieldFill';
/** @hidden */
export const afterFormFieldFillEvent = 'afterFormFieldFill';
/** @hidden */
export const beforeFormFieldFillEvent = 'beforeFormFieldFill';
/** @hidden */
export const serviceFailureEvent = 'serviceFailure';
/** @hidden */
export const viewChangeEvent = 'viewChange';
/** @hidden */
export const customContextMenuSelectEvent = 'customContextMenuSelect';
/** @hidden */
export const customContextMenuBeforeOpenEvent = 'customContextMenuBeforeOpen';
/** @hidden */
export const contentControlEvent = 'contentControl';
/** @hidden */
export const beforecontentControlFillEvent = 'beforeContentControlFill';
/** @hidden */
export const aftercontentControlFillEvent = 'afterContentControlFill';
/** @hidden */
export const commentBeginEvent = 'commentBegin';
/** @hidden */
export const commentEndEvent = 'commentEnd';
/** @hidden */
export const beforeCommentActionEvent = 'beforeCommentAction';
/** @hidden */
export const commentDeleteEvent = 'commentDelete';
/** @hidden */
export const revisionActionEvent = 'beforeAcceptRejectChanges';
/** @hidden */
export const beforePaneSwitchEvent = 'beforePaneSwitch';
/** @hidden */
export const requestNavigateEvent = 'requestNavigate';
/** @hidden */
export const actionCompleteEvent = 'actionComplete';
/** @hidden */
export const trackChangeEvent = 'trackChange';
/** @hidden */
export const searchResultsChangeEvent = 'searchResultsChange';
/** @hidden */
export const keyDownEvent = 'keyDown';
/** @hidden */
export const toolbarClickEvent = 'toolbarClick';
/** @hidden */
export const beforeFileOpenEvent = 'beforeFileOpen';
/** @hidden */
export const internalviewChangeEvent = 'internalviewChange';
/** @hidden */
export const beforeXmlHttpRequestSend = 'beforeXmlHttpRequestSend';
/** @hidden */
export const protectionTypeChangeEvent = 'protectionTypeChange';
/** @hidden */
export const internalDocumentEditorSettingsChange = 'internalDocumentEditorSettingsChange';
/** @hidden */
export const internalStyleCollectionChange = 'internalStyleCollectionChange';
/** @hidden */
export const internalAsyncPagesVisible = 'internalAsyncPagesVisible';
/** @hidden */
export const defaultFont = 'Times New Roman';
/** @hidden */
export const internalAutoResize = 'internalAutoResize';
/** @hidden */
export const beforeAutoResize = 'beforeAutoResize';
/** @hidden */
export const trackChanges = 'trackChanges';
/** @hidden */
export const internalOptionPaneChange = 'internalOptionPaneChange';
/** @hidden */
export const documentLoadFailedEvent = 'documentLoadFailed';
/**
 * File menu item click event
 * @hidden
 */
export const fileMenuItemClickEvent = 'fileMenuItemClick';
/**
 * Triggered before paste operation is executed
 *
 * @hidden
 */
export const beforePaste = 'beforePaste';
/**
 * Triggers when pages loads asynchronously in the document editor
 * @hidden
 */
export const asyncPagesVisible = 'asyncPagesVisible';
/**
 * Triggered when the border style other than solid type is clicked
 *
 * @hidden
 */
export const unsupportedBorderStyleClick = 'unsupportedBorderStyleClick';
